import { useState } from 'react';
import * as React from 'react';
import { Button, Select, Space } from 'antd';
import {
  PlayCircleOutlined,
  BellOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import { getToken } from '../../utils/localstorage';
import { logger } from '../../helpers/tslog';

const { Option } = Select;

interface PromptProps { }

const Prompt: React.FC<PromptProps> = () => {
  const [snoozeDuration, setSnoozeDuration] = useState<number>(5);

  const downloadTemplateFile = async (documentId: string, filename: string, headers = {}) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/document-part`, {
        params: {
          documentId,
          type: 'excel',
        },
        headers,
      });

      if (!response.data.files || response.data.files.length === 0) {
        throw new Error('No excel files found');
      }

      const excelFile = response.data.files[0];
      const binaryString = window.atob(excelFile.content);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: excelFile.mimeType });

      // Prompt the user with the native Save As dialog
      const handle = await (window as any).showSaveFilePicker({
        suggestedName: filename + '.xlsx',
      });

      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();

      logger.info('File saved successfully!');
    } catch (err) {
      logger.error('Failed to save file:', err);
    }
  };

  const handleGenerate = async () => {
    await Office.onReady()
    const token = await getToken();
    const documentId = new URLSearchParams(window.location.search).get('documentId');
    if (!documentId) {
      logger.error('No document ID found');
      return;
    }
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    // Temporary arguments
    await downloadTemplateFile(
      documentId,
      `AlphaScript_Share_Price_Performance_Line_Chart_${formattedDate}`,
      {
        Authorization: `Bearer ${token}`,
      }
    );

    Office.context.ui.messageParent(JSON.stringify({ type: "generate" }));
  };

  const handleSnooze = () => {
    Office.onReady().then(() => {
      Office.context.ui.messageParent(JSON.stringify({ type: "snooze", duration: snoozeDuration }));
    });
  };

  const handleDismiss = () => {
    Office.onReady().then(() => {
      Office.context.ui.messageParent(JSON.stringify({ type: "dismiss" }));
    });
  };

  return (
    <div style={{ fontFamily: 'Segoe UI, sans-serif' }}>
      <h3 style={{
        marginBottom: 20,
        backgroundColor: '#003550',
        color: '#fff',
        padding: 10,
        textAlign: 'center'
      }}>
        AlphaScript Content is Ready!
      </h3>

      <div style={{ marginLeft: 10, marginRight: 10 }}>
        <Space
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: 20,
          }}
        >
          <Button
            type="primary"
            icon={<PlayCircleOutlined />}
            onClick={handleGenerate}
          >
            Generate
          </Button>
          <Button icon={<BellOutlined />} onClick={handleSnooze}>
            Snooze
          </Button>
          <Button
            type="primary"
            danger
            icon={<CloseOutlined />}
            onClick={handleDismiss}
          >
            Dismiss
          </Button>
        </Space>

        <div>
          <label htmlFor="snooze-select" style={{ display: 'block', marginBottom: 8 }}>
            If snooze, for how long:
          </label>
          <Select
            id="snooze-select"
            value={snoozeDuration}
            onChange={(value: number) => setSnoozeDuration(value)}
            style={{ width: '100%' }}
          >
            <Option value={5}>5 minutes</Option>
            <Option value={10}>10 minutes</Option>
            <Option value={15}>15 minutes</Option>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default Prompt;
